import { axios } from '@Root/API'

export const deleteSubmission = (id, formId, includeSynced = false) => {
  return axios.delete(`cognito-submissions/${id}`, {
    params: {
      cognito_form_id: formId,
      include_synced: includeSynced ? 1 : 0,
    },
  })
}

export const deleteSubmissions = (formId, ids, includeSynced = false) => {
  return axios.post('cognito-submissions/bulk-delete', {
    cognito_form_id: formId,
    ids,
    include_synced: includeSynced,
  })
}
